import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  master: null,
}

const masterModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
export default masterModule
